import { BsInfoLg } from 'react-icons/bs'

import styled, { css } from 'styled-components'

import { Colours } from '@lib/theme'

import { LightTooltip } from './LightTooltip'

export interface Props {
  hint?: string
  size?: 'small' | 'normal'
  colour?: 'normal' | 'attention'
}

export function Hint({ hint, size = 'normal', colour = 'normal' }: Props) {
  if (!hint) {
    return null
  }

  let circleSize = '1rem'
  if (size === 'small') {
    circleSize = '0.7rem'
  }

  let iconSize = '0.8rem'
  if (size === 'small') {
    iconSize = '0.5rem'
  }

  return (
    <LightTooltip title={hint} placement="right">
      <IconButton
        type="button"
        tabIndex={-1}
        $size={circleSize}
        $colour={colour}
      >
        <BsInfoLg color={Colours.BgShade.Dark} size={iconSize} />
      </IconButton>
    </LightTooltip>
  )
}

const NormalColour = css`
  background-color: ${Colours.FgShade.Light};
  :hover,
  :focus {
    background-color: ${Colours.Brand.BlueMid};
  }
`

const AttentionColour = css`
  background-color: ${Colours.Brand.BlueMid};
  :hover,
  :focus {
    filter: brightness(1.2);
  }
`

const IconButton = styled.button<{
  $size: string
  $colour: 'normal' | 'attention'
}>`
  border: none;
  font-size: 18px;
  border-radius: 50%;
  margin: 0;
  margin-left: 0.5rem;
  padding: 0;

  ${({ $colour }) => {
    switch ($colour) {
      case 'attention':
        return AttentionColour
      case 'normal':
      default:
        return NormalColour
    }
  }}

  display: flex;
  align-items: center;
  justify-content: center;

  height: ${({ $size }) => $size};
  width: ${({ $size }) => $size};
`
